var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"target",style:(_vm.canvasStyle),on:{"click":_vm.cancelFocus,"drop":_vm.appendComponentList}})}
var staticRenderFns = []

export { render, staticRenderFns }